import * as service from './service';

export const configurationStore = {
  service,
};
